// extracted by mini-css-extract-plugin
module.exports = {"container":"SignUpConfirm_container__39JF_","section":"SignUpConfirm_section__3wqyH"};